import axios, { AxiosRequestConfig } from "axios";
import { AppConfig } from "@/config";

const baseConfig: AxiosRequestConfig = {
  baseURL: AppConfig.apiBaseUrl || "http://localhost:8000",
  // 20s tolerates DRF list endpoints with filters + heavy serialization.
  // The 10s default was too tight for paginated /get-ready/requests/.
  // Auth header injection + 401 refresh-and-retry are wired in
  // setupAuthInterceptors() (src/lib/services/auth-refresh.ts) and
  // installed once at app boot from src/app/index.tsx.
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
};

export const apiClient = axios.create(baseConfig);
